function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("title", null, "T@3x");

var _ref3 =
/*#__PURE__*/
React.createElement("desc", null, "Created with Sketch.");

var _ref4 =
/*#__PURE__*/
React.createElement("g", {
  id: "Symbols",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "footer",
  transform: "translate(-146.000000, -245.000000)"
}, React.createElement("g", {
  id: "Group-6",
  fill: "#A6A6B4"
}, React.createElement("rect", {
  id: "Rectangle",
  x: 0,
  y: 0,
  width: 1440,
  height: 339
})), React.createElement("path", {
  d: "M160.644882,249.005613 C159.374001,247.082522 154.625708,247.896292 155.4484,251.631141 C151.298906,251.668385 149.055532,248.561885 149.055532,248.561885 C149.055532,248.561885 147.63485,250.780928 149.95272,252.592286 C149.504126,252.62953 148.644591,252.333978 148.644591,252.333978 C148.644591,252.333978 148.308146,254.257069 150.999304,255.218214 C150.737759,255.551011 149.653927,255.329146 149.653927,255.329146 C149.653927,255.329146 149.95272,256.993129 152.420391,257.474102 C150.737759,259.027152 147.821899,258.546179 148.008543,258.694355 C150.438562,260.912998 161.317773,261.393571 161.430326,251.113725 C161.990664,250.928704 163,249.412498 163,249.412498 C163,249.412498 161.467169,249.856227 161.355021,249.818982 C162.551406,249.116546 162.588654,248.192244 162.588654,248.192244 C162.588654,248.192244 161.205624,248.931926 160.644882,249.005613 Z",
  id: "Fill-1",
  fill: "#FFFFFF"
})));

var SvgTwitter = function SvgTwitter(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: "18px",
    height: "18px",
    viewBox: "0 0 18 18",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgTwitter, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/twitter.1fefb5e6.svg";
export { ForwardRef as ReactComponent };